import { render } from "./CardSetAssemblyList.vue?vue&type=template&id=720b9d01&scoped=true&ts=true"
import script from "./CardSetAssemblyList.vue?vue&type=script&lang=ts"
export * from "./CardSetAssemblyList.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720b9d01"]])

export default __exports__